import React, { Fragment, useEffect, useState } from 'react';
import {css, Global, keyframes} from '@emotion/react';
import {BrowserRouter as Router, Switch, Route, Redirect, useHistory, Link} from 'react-router-dom';

export default ({size=24}) => {
  const animation = keyframes`
    100% {
      transform: rotate(360deg);
      transform-origin: center;
    }
  `;

  return <span className="material-icons" css={css`font-size: ${size}px; width: ${size}px; height: ${size}px; color: #EEE; animation: ${animation} 3s infinite linear`}>donut_large</span>;
};
